import type { DocumentTemplateKey } from "@platform/contracts";
import { api } from "./api";
import { DEFAULT_TEMPLATES, documentShell, renderTemplate } from "./printing";

let cache: { templates: Partial<Record<DocumentTemplateKey, string>>; logoUrl: string | null } | null = null;

export function invalidateDocumentCache(): void { cache = null; }

async function context(): Promise<{ templates: Partial<Record<DocumentTemplateKey, string>>; logoUrl: string | null }> {
  if (cache) return cache;
  const [templates, branding] = await Promise.all([
    api.templates().then((result) => result.templates).catch(() => []),
    api.branding().catch(() => ({ logoVersion: null }))
  ]);
  cache = {
    templates: Object.fromEntries(templates.filter((template) => template.isCustom && template.html.trim()).map((template) => [template.key, template.html])),
    logoUrl: branding.logoVersion ? new URL(api.brandingLogoUrl(branding.logoVersion), window.location.origin).toString() : null
  };
  return cache;
}

export async function templateFor(key: DocumentTemplateKey): Promise<string> {
  return (await context()).templates[key] ?? DEFAULT_TEMPLATES[key];
}
export async function logoUrl(): Promise<string | null> { return (await context()).logoUrl; }

/** Renders one or more records through a template into a complete printable document. */
export async function renderDocument(key: DocumentTemplateKey, title: string, records: Record<string, unknown>[]): Promise<string> {
  const template = await templateFor(key);
  return documentShell(title, records.map((data) => renderTemplate(template, data)).join(""));
}
